import { CommandsDirectory } from "@components/commands/lib";
import { Shortcut } from "@components/commands/Shortcut";
import { useCommands } from "@components/commands/useCommands";
import { Dropdown } from "react-bootstrap";
import { FC } from "react";
import { useMultikeyKeyboardCommand } from "@hooks/keyboard/useMultikeyKeyboardCommands";
import styles from "./NavigationDropdown.module.scss";

interface WorkspaceSwitcherItemProps {
    disabled?: boolean;
}

export const WorkspaceSwitcherItem: FC<WorkspaceSwitcherItemProps> = ({
    disabled,
}) => {
    const { open: openCommands } = useCommands();

    useMultikeyKeyboardCommand({
        command: {
            keys: "ow",
            callback: () => openCommands(CommandsDirectory.WORKSPACES),
        },
    });

    return (
        <Dropdown.Item
            onClick={() => openCommands(CommandsDirectory.WORKSPACES)}
            disabled={disabled}
            className={styles.dropdownMenuSwitchWorkspaceItem}
            data-testid="switch-workspace-button"
        >
            Switch workspace{" "}
            <div className={styles.dropdownMenuSwitchWorkspaceIconContainer}>
                <Shortcut keys={["O", "W"]} />
            </div>
        </Dropdown.Item>
    );
};
